import locale from "locale";

const FIELDS_OPTIONS = [
    {
        label: locale("email.eventCalendarOnlineTitle"),
        styles: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
        },
        callbackKey: "online",
    },
    {
        label: locale("email.eventCalendarOfflineTitle"),
        styles: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
        },
        callbackKey: "offline",
    },
];

const MODEL_ADAPTER = {
    online: {
        addLinkToOnlineDescription: "addLinkToDescription",
        onlineEventDescriptionRu: "eventDescriptionRu",
        onlineEventDescriptionEn: "eventDescriptionEn",
        onlineEventNameRu: "eventNameRu",
        onlineEventNameEn: "eventNameEn",
    },
    offline: {
        addLinkToOfflineDescription: "addLinkToDescription",
        offlineEventDescriptionRu: "eventDescriptionRu",
        offlineEventDescriptionEn: "eventDescriptionEn",
        offlineEventNameRu: "eventNameRu",
        offlineEventNameEn: "eventNameEn",
        addOfflineAddress: "addAddress",
        offlineAddress: "address",
    },
};

const PARTICIPATION_TYPE_HYBRID = 'hybrid';

export { FIELDS_OPTIONS, MODEL_ADAPTER, PARTICIPATION_TYPE_HYBRID };
